// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"TypeCodeModalComponent_modalBody__1tQMT","modalFooter":"TypeCodeModalComponent_modalFooter__3kg_v","highlight":"TypeCodeModalComponent_highlight__3DtYa"};